import {
  BugAntIcon,
  ChevronRightIcon,
  DocumentTextIcon,
  PhoneIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';
import { FlagIcon } from '@heroicons/react/24/solid';

import { Popup, PopupMenu, PopupMenuItem } from '~/components/Popup';
import { useUser } from '~/providers';
import { cn } from '~/utils';
import { trackButtonClick } from '~/utils/analytics';

import { SidebarCardButton } from './SidebarCardButton';

type LinksButtonType = {
  minimise: boolean;
};

export const SidebarLinks = ({ minimise }: LinksButtonType) => {
  const { user, account } = useUser();

  const triggerButton = (
    <SidebarCardButton className="group cursor-default">
      <QuestionMarkCircleIcon
        className={cn('text-white-off hidden size-4', {
          block: minimise,
        })}
      />
      {!minimise && (
        <>
          <div className="flex w-20 flex-col text-left">
            <p className="text-neutral-350 group-hover:text-neutral-250! text-xs leading-normal font-medium transition-all">
              Help
            </p>
          </div>

          <ChevronRightIcon className="text-neutral-350 group-hover:text-neutral-250! h-3 transition-all" />
        </>
      )}
    </SidebarCardButton>
  );

  const isFree = account.features.free_access?.amount === 1;
  const isPro = account.features.flex_access?.amount === 1;

  return (
    <Popup
      fallback={triggerButton}
      trigger={triggerButton}
      position="right bottom"
      arrow={false}
    >
      <PopupMenu
        origin="bottom-left"
        className="shadow-m border-primary-500 bg-primary-550 ml-2 flex flex-col gap-1 rounded-md border p-1"
      >
        {isFree || isPro ? (
          <PopupMenuItem
            Icon={BugAntIcon}
            className="bg-primary-550! text-neutral-350! hover:bg-primary-500! hover:text-neutral-250! border-none!"
          >
            <a href="/feedback" target="_blank" rel="noreferrer noopener">
              <p className="text-xs leading-normal text-inherit!">
                Report Issue
              </p>
            </a>
          </PopupMenuItem>
        ) : null}

        <PopupMenuItem
          Icon={FlagIcon}
          className="bg-primary-550! text-neutral-350! hover:bg-primary-500! hover:text-neutral-250! border-none!"
        >
          <a
            href="https://status.raffle.ai/"
            target="_blank"
            rel="noreferrer noopener"
          >
            <p className="text-xs leading-normal text-inherit!">Status Page</p>
          </a>
        </PopupMenuItem>

        <PopupMenuItem
          Icon={DocumentTextIcon}
          className="bg-primary-550! text-neutral-350! hover:bg-primary-500! hover:text-neutral-250! border-none!"
        >
          <a
            href="https://raffle.ai/docs/home"
            target="_blank"
            rel="noreferrer noopener"
            onClick={() =>
              trackButtonClick({
                buttonName: 'Docs',
                user,
                account,
                variant: 'secondary',
                location: 'sidebar',
              })
            }
          >
            <p className="text-xs leading-normal text-inherit!">
              Documentation
            </p>
          </a>
        </PopupMenuItem>

        <PopupMenuItem
          Icon={PhoneIcon}
          className="bg-primary-550! text-neutral-350! hover:bg-primary-500! hover:text-neutral-250! border-none!"
        >
          <a href="mailto:support@raffle.ai" target="_blank" rel="noreferrer">
            <p className="text-xs leading-normal text-inherit!">Contact Us</p>
          </a>
        </PopupMenuItem>
      </PopupMenu>
    </Popup>
  );
};
